import { render, staticRenderFns } from "./PdfUpload.vue?vue&type=template&id=2cd43840&"
import script from "./PdfUpload.vue?vue&type=script&lang=js&"
export * from "./PdfUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports